import { useEffect, useState } from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import { Formik, Field, Form, ErrorMessage } from "formik";
import styles from "./Modal.module.scss";
import * as Yup from "yup";
import PhoneInputNumber from "../Form/MobileInput";
import { FiInfo } from "react-icons/fi";
import FileInputField from "../Form/FileInput";
import { ApplicantActions } from "../../../actions";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import Select from "react-select";
import { jobProfileActions } from "../../../actions";

export default function ReferalModal({
  visible,
  toggle,
  currentModalIndex,
  setCurrentModalIndex,
  selectedRoundCardsLength,
  showPrevNext,
  ...props
}) {
  const inetviewer = useSelector((state) => state.jobProfiles.searchUser);
  const [fieldValue, setFieldValue] = useState("");
  const Role = useSelector((state) => state.authentication.user.userRole);

  useEffect(() => {
    dispatch(jobProfileActions.getSearchApi());
  }, []);

  const options =
    inetviewer?.map((val) => ({
      value: val.id,
      label: val.name,
    })) || [];

  useEffect(() => {
    if (!visible) {
      setFieldValue("");
    }
  }, [visible]);

  const initialValues = {
    name: "",
    phone: "",
    email: "",
    resume: null,
    jobTitle: props?.jobTitle,
    jobProfile: props?.jobProfileName,
    jobid: props?.jobId,
    referredBy: "",
  };
  const validationSchema = Yup.object().shape({
    name: Yup.string().required("First Name is required"),
    phone: Yup.string().required("Phone No is required"),
    email: Yup.string()
      .required("Email is required")
      .email("Invalid email address"),
    resume: Yup.mixed().required("Resume is required"),
    jobTitle: Yup.string().required("Job Title is required"),
    jobProfile: Yup.string().required("Job Profile is required"),
  });

  const onSubmit = (values) => {
    if (values && props?.jobTitle) {
      let reqBody = {
        name: values.name,
        phone: values.phone,
        email: values.email,
        resume: values.resume,
        jobid: props?.jobId,
        source: 3,
        country: values.country,
        referredBy: fieldValue,
      };
      dispatch(ApplicantActions.createApplicant(reqBody)).then((res) => {
        if (res) {
          toast.success("Candidate has been referred successfully");
          toggle();
        }
      });
    } else if (!props?.jobTitle) {
      let reqBody = {
        name: values.name,
        phone: values.phone,
        email: values.email,
        resume: values.resume,
        referralJobProfile: values.jobProfile,
        referralJobTitle: values.jobTitle,
        country: values.country,
        referredBy: fieldValue,
      };
      dispatch(ApplicantActions.candidateReferral(reqBody)).then((res) => {
        if (res) {
          toast.success("Candidate has been referred successfully");
          toggle();
        }
      });
    }
  };
  const dispatch = useDispatch();

  return (
    <Modal
      isOpen={visible}
      toggle={toggle}
      centered
      size={props.size ? props.size : "lg"}
      backdrop="static"
    >
      <ModalHeader className="modal-title border-0 pb-1" toggle={toggle}>
        Referral
      </ModalHeader>
      <ModalBody>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={onSubmit}
          className="container"
        >
          {({ errors, touched }) => (
            <Form className="row">
              <div className="form-group col-12 col-md-6 mb-3">
                <label className="form-label fw-semibold mb-2">Job Title</label>
                <Field
                  type="text"
                  className="form-control"
                  name="jobTitle"
                  placeholder="Job Title"
                  disabled={props?.jobTitle ? true : false}
                />
                {errors.jobTitle && touched.jobTitle ? (
                  <div className={styles.formError}>{errors.jobTitle}</div>
                ) : null}
              </div>

              <div className="form-group col-12 col-md-6 mb-3">
                <label className="form-label fw-semibold mb-2">
                  Job Profile
                </label>
                <Field
                  type="text"
                  className="form-control"
                  name="jobProfile"
                  placeholder="Job Profile"
                  disabled={props?.jobProfileName ? true : false}
                />
                {errors.jobProfile && touched.jobProfile ? (
                  <div className={styles.formError}>{errors.jobProfile}</div>
                ) : null}
              </div>

              <div className="form-group col-12 col-md-6 mb-3">
                <label className="form-label fw-semibold mb-2">Name</label>
                <Field
                  type="text"
                  className="form-control"
                  name="name"
                  placeholder="Name"
                />
                {errors.name && touched.name ? (
                  <div className={styles.formError}>{errors.name}</div>
                ) : null}
              </div>

              <div className="form-group col-12 col-md-6 mb-3">
                <label className="form-label fw-semibold mb-2">Phone No</label>
                <PhoneInputNumber name="phone" autocomplete="off" />
                {errors.phone && touched.phone ? (
                  <div className={styles.formError}>{errors.phone}</div>
                ) : null}
              </div>

              <div className="form-group col-12 col-md-6 mb-3">
                <label className="form-label fw-semibold mb-2">Email</label>
                <Field
                  type="email"
                  className="form-control"
                  name="email"
                  placeholder="Email"
                />
                {errors.email && touched.email ? (
                  <div className={styles.formError}>{errors.email}</div>
                ) : null}
              </div>

              <div className="form-group col-12 col-md-6 mb-3">
                <label className="form-label fw-semibold mb-2 me-2">
                  Resume{" "}
                  <FiInfo
                    className="infoIcon"
                    title="Only pdf file up to 1 MB is allowed"
                  />
                </label>
                <FileInputField name="resume" />

                {errors.resume && touched.resume ? (
                  <div className={styles.formError}>{errors.resume}</div>
                ) : null}
              </div>

              {Role && Role != 4 && (
                <div className="form-group col-12 col-md-6 mb-3">
                  <label className="form-label fw-semibold mb-2 me-2">
                    Referred By
                  </label>
                  <Select
                    name="referredBy"
                    options={[{ value: "", label: "Me" }, ...options]}
                    onChange={(option) => {
                      setFieldValue(option.value);
                    }}
                    defaultValue={{ value: null, label: "Me" }}
                    placeholder="Select Referred By"
                  />
                </div>
              )}

              <div className="col-12 d-flex align-items-center justify-content-end">
                <button
                  type="submit"
                  className={styles.btnRefer + " btn w-auto"}
                >
                  Submit
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </ModalBody>
    </Modal>
  );
}
